/**
 * Nähateliers aus dem Code: Jedes rechnet anders, deshalb bringt jedes seine
 * eigene Preisstruktur mit. Das Dashboard baut den Editor aus `abschnitte` und
 * kennt kein Atelier namentlich.
 */
/** Alle Zeilen in Editor-Reihenfolge. */
export function atelierZeilen(modul) {
    return modul.abschnitte.flatMap((a) => a.zeilen);
}
/**
 * Wert einer Zeile: der gespeicherte, sonst der Startwert des Moduls. So zeigt eine
 * ältere Liste Zeilen, die das Modul später bekommen hat, mit dem Preis aus dem PDF;
 * erst beim Speichern landen sie in der Liste. Unbekannte Zeilen → 0.
 */
export function atelierWert(modul, preise, schluessel) {
    return preise.werte[schluessel] ?? modul.startwerte.werte[schluessel] ?? 0;
}
//# sourceMappingURL=typen.js.map